import rentIntentionSchema from './schemas/rentIntentionSchema'
import documentsSchema from './schemas/documentsSchema'
import contractSchema from './schemas/contractSchema'
import incomeSchema from './schemas/incomeSchema'
import profileSchema from './schemas/profileSchema'
import submitSchema from './schemas/SubmitSchema'
import toPath from 'lodash/toPath'
import cloneDeep from 'lodash/cloneDeep'
import isInteger from 'lodash/isInteger'
import * as Sentry from '@sentry/browser'

function yupToFormErrors(yupError) {
  let errors = {}
  for (let err of yupError.inner) {
    if (!errors[err.path]) {
      errors = setIn(errors, err.path, err.message)
    }
  }
  return errors
}

function getIn(obj, key, def, p = 0) {
  const path = toPath(key)
  while (obj && p < path.length) {
    obj = obj[path[p++]]
  }
  return obj === undefined ? def : obj
}

function setIn(obj, path, value) {
  let res = {}
  let resVal = res
  let i = 0
  let pathArray = toPath(path)

  for (; i < pathArray.length - 1; i++) {
    const currentPath = pathArray[i]
    let currentObj = getIn(obj, pathArray.slice(0, i + 1))

    if (resVal[currentPath]) {
      resVal = resVal[currentPath]
    } else if (currentObj) {
      resVal = resVal[currentPath] = cloneDeep(currentObj)
    } else {
      const nextPath = pathArray[i + 1]
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {}
    }
  }

  if (value === undefined) {
    delete resVal[pathArray[i]]
  } else {
    resVal[pathArray[i]] = value
  }

  const result = { ...obj, ...res }

  // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
  if (i === 0 && value === undefined) {
    delete result[pathArray[i]]
  }

  return result
}

const validateProfile = information => {
  return profileSchema.validate(information, { abortEarly: false }).catch(err => {
    const errors = yupToFormErrors(err)
    console.warn(errors)
    Sentry.addBreadcrumb({
      category: 'validation',
      data: errors,
      message: 'Validation failed',
      level: Sentry.Severity.Info,
    })
    throw errors
  })
}

const validateRentIntention = (application, asBool) => {
  return asBool
    ? rentIntentionSchema.isValidSync(application)
    : rentIntentionSchema.validate(application, { abortEarly: false }).catch(err => {
        const errors = yupToFormErrors(err)
        console.warn(errors)
        Sentry.addBreadcrumb({
          category: 'validation',
          data: errors,
          message: 'Validation failed',
          level: Sentry.Severity.Info,
        })
        throw errors
      })
}

const validateContract = (application, asBool, isBrusselsZip) =>
  asBool
    ? contractSchema.isValidSync(application, { context: { isBrusselsZip } })
    : contractSchema.validate(application, { abortEarly: false, context: { isBrusselsZip } }).catch(err => {
        const errors = yupToFormErrors(err)
        console.warn(errors)
        Sentry.addBreadcrumb({
          category: 'validation',
          data: errors,
          message: 'Validation failed',
          level: Sentry.Severity.Info,
        })
        throw errors
      })

const validateIncome = (application, asBool) => {
  return asBool
    ? incomeSchema.isValidSync(application)
    : incomeSchema.validate(application, { abortEarly: false }).catch(err => {
        const errors = yupToFormErrors(err)
        console.warn(errors)
        Sentry.addBreadcrumb({
          category: 'validation',
          data: errors,
          message: 'Validation failed',
          level: Sentry.Severity.Info,
        })
        throw errors
      })
}

const validateDocuments = (application, asBool, isBrusselsZip = false) => {
  return asBool
    ? documentsSchema.isValidSync(application, { context: { isBrusselsZip } })
    : documentsSchema.validate(application, { abortEarly: false, context: { isBrusselsZip } }).catch(err => {
        const errors = yupToFormErrors(err)
        console.warn(errors)
        Sentry.addBreadcrumb({
          category: 'validation',
          data: errors,
          message: 'Validation failed',
          level: Sentry.Severity.Info,
        })
        throw errors
      })
}

const validateOverview = (application, asBool) => {
  return asBool
    ? submitSchema.isValidSync(application)
    : submitSchema.validate(application, { abortEarly: false }).catch(err => {
        const errors = yupToFormErrors(err)
        console.warn(errors)
        Sentry.addBreadcrumb({
          category: 'validation',
          data: errors,
          message: 'Validation failed',
          level: Sentry.Severity.Info,
        })
        throw errors
      })
}

const validateApplication = (application, items, isBrusselsZip = false) => {
  const validators = {
    residents: () => true,
    contract: validateContract,
    rentIntention: validateRentIntention,
    income: validateIncome,
    documents: validateDocuments,
    overview: validateOverview,
  }

  return items.map(item => validators[item](application, true, isBrusselsZip)).every(item => item)
}

export {
  rentIntentionSchema,
  documentsSchema,
  contractSchema,
  validateRentIntention,
  validateContract,
  validateIncome,
  validateDocuments,
  validateProfile,
  validateApplication,
  validateOverview,
}



// WEBPACK FOOTER //
// ./src/utils/validation/index.js